
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SoundMixin extends Vue {
  playNotification() {
    const audio = new Audio(require("../assets/sounds/notification.mp3"));
    audio.play();
  }
}
